<template>
  <div class="umesr-page">
    <page-header
      :actions="pageHeaderActionsConfig"
      class="umesr-page__page-header"
      left-side-class="col-xl-4"
      :page="pageHeaderConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    />

    <filter-manager
      v-model="selectedFilters"
      class="umesr-page__filter-manager"
      :filters="filtersConfig"
      @search="search"
    />

    <custom-separator class="pt-3 my-4" text="Resultados" />

    <umesr-list v-model="results" @on-delete="onDeleteHandler" />

    <custom-result-not-found
      v-if="results.length === 0"
      text="No se encontraron hallazgos en el sistema"
    />
    <pagination
      v-if="results.length > 0 && pagination.totalItemCount > pageSize"
      :data="pagination"
      :show-text="true"
      @pagination-go-page="goToPageHandler"
    />
  </div>
</template>

<script>
import UmesrList from './components/UmesrList';
import CustomSeparator from 'custom-separator';
import { providersAcademicYear } from '@/modules/provider/api';
import {
  getUmesrAcademicYears,
  getUmesrFilters,
  getSearch,
  removeUmesrFindingsById,
} from '@/modules/umesr/api';

import CustomResultNotFound from 'custom-result-not-found';
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import Pagination from 'pagination';
import storeMixin from '@/shared/mixins/storeGenerator';
import alertMixin from 'utils/mixins/alert.mixin';

export default {
  components: {
    CustomSeparator,
    CustomResultNotFound,
    UmesrList,
    PageHeader,
    FilterManager,
    Pagination,
  },
  mixins: [storeMixin, alertMixin],
  data: () => ({
    pageHeaderConfig: {
      title: 'Hallazgo UMESR',
      icon: 'fas fa-user-tie',
      routes: ['Proveedor', 'Historial de Hallazgos UMESR'],
    },
    selectedFilters: {
      academicYear: null,
      provider: null,
      finding: null,
      status: null,
      referralNumber: null,
    },
    filters: {
      years: [],
      providers: [],
      findings: [],
      status: [],
    },
    results: [],
    pagination: {
      totalItemCount: 0,
      count: 0,
      pageCount: 0,
      currentPage: 1,
    },
    pageSize: 15,
  }),
  computed: {
    filtersConfig() {
      return [
        {
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filters.years,
          placeholder: 'Seleccione el año',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          initialValue: this.$store.state.$_common.currentAcademicYear,
          onChanged: this.onYearChanged,
        },
        {
          name: 'provider',
          component: 'CustomDropDown',
          options: this.filters.providers,
          placeholder: 'Seleccione el proveedor',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-8',
          returnModel: true,
        },
        {
          name: 'finding',
          component: 'CustomDropDown',
          options: this.filters.findings,
          placeholder: 'Seleccione',
          label: 'Hallazgo:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-5',
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filters.status,
          placeholder: 'Seleccione',
          label: 'Estatus:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-3',
        },
        {
          name: 'referralNumber',
          component: 'CustomInput',
          icon: 'fas fa-search color-primary-2',
          leftIcon: true,
          options: this.filters.referralNumber,
          placeholder: 'Escriba número de referido o SIE.',
          label: 'Número de Referido o SIE:',
          isAdvanced: true,
        },
      ];
    },
    pageHeaderActionsConfig() {
      return [
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus',
          variant: 'success',
          component: 'ActionButton',
          click: () => {
            this.$router.push({
              name: 'UmesrCreate',
            });
          },
        },
      ];
    },
  },
  mounted() {
    getUmesrAcademicYears().then(({ data }) => (this.filters.years = data));
    this.onYearChanged(this.$store.state.$_common.currentAcademicYear);
    getUmesrFilters().then(
      ({ data }) => (
        (this.filters.status = data.collections.status),
        (this.filters.findings = data.collections.findings)
      )
    );
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    onYearChanged(model) {
      providersAcademicYear({ fiscalYearId: model?.id }).then(
        ({ data }) => (this.filters.providers = data)
      );
    },
    goToPageHandler(pageIndex) {
      this.search(null, pageIndex);
    },
    async search(filter, currentPage) {
      const filterModel = {
        AcademicYearId: this.selectedFilters.academicYear.id,
        providerId: this.selectedFilters.provider?.id, //Repetido? (Columna Comment?)
        findId: this.selectedFilters.finding?.id,
        statusId: this.selectedFilters.status?.id,
        searchText: this.selectedFilters.referralNumber,
        pageSize: this.pageSize,
        currentPage:
          currentPage == null ? this.pagination.currentPage : currentPage,
      };
      let self = this;
      await getSearch(filterModel).then(({ data }) => {
        self.results = data.data.map((row) => {
          return {
            ...row,
            isOpen: false,
          };
        });
        self.pagination.totalItemCount = data.totalItemCount;
        self.pagination.pageCount = data.pageCount;
        self.pagination.count = data.count;
        self.pagination.currentPage = data.currentPage;
      });
    },
    async onDeleteHandler(id) {
      await removeUmesrFindingsById(id)
        .then(() => {
          this.ShowToast(
            'Proceso exitoso',
            'El hallazgo ha sido eliminado exitosamente.',
            'success'
          );

          this.search();
        })
        .catch((error) => {
          this.ShowToast('Alerta', error.response.data.message, 'error');
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';

.umesr-page {
  &__filter-manager ::v-deep {
    .custom-ddl {
      font-size: 14px;
    }

    div[name='referralNumber'] {
      margin-top: -0.25rem;
    }

    .ab-btn.success {
      width: 70%;
    }

    // @todo put a selector more scalable
    & > span > .row > .col-sm > .d-flex.justify-content-md-end {
      justify-content: flex-end !important;

      @media only screen and (max-width: 768px) {
        padding-right: 15px;
        margin-top: 15px;
      }
    }
  }
}
</style>
